/* eslint-disable no-mixed-spaces-and-tabs */
import axios from 'axios';
import React, { useRef, useState } from 'react';
import { BsXLg } from 'react-icons/bs';
import { useMutation } from 'react-query';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import axiosInstance from '../../../config/axiosInstance';
import { globalEnv } from '../../../config/baseConfig';
import { useTypedSelector } from '../../../hooks/useTypeSelector';
import { SetNotificationAction } from '../../../redux/actions/notificationAction';
import RemoveModal from '../../Utils/Components/modals/removeModal';
import { stateNotificationsEnum } from '../../Utils/notification';

type dashCardType = {
	dashboardId: string;
	userId: string;
	image: string;
	name: string;
	defaultDash: string;
	setDefaultDash: (id: string) => void;

	dashboardList: any[];
	setDashboards: (dashboards: any[]) => void;
};

export function DashCard({
	dashboardId,
	userId,
	image,
	name,
	defaultDash,
	setDefaultDash,
	dashboardList,
	setDashboards
}: dashCardType) {
	const [isRemoveModalOpen, setIsRemoveModalOpen] = useState(false);
	const { ACCESS_TOKEN } = useTypedSelector((state) => state.auth);

	const dispatch = useDispatch();

	interface IDeleteDash {
		userId: string;
		dashboardId: string;
	}
	const deleteDashReq = async (data: IDeleteDash) => {
		const { data: response } = await axiosInstance().delete(
			globalEnv.BASE_URL + '/dashboard/delete',
			{
				data: {
					dashboardId: data.dashboardId,
					userId: data.userId
				},
				headers: {
					Authorization: 'Bearer ' + ACCESS_TOKEN
				}
			}
		);
		return response;
	};

	const { mutate } = useMutation(deleteDashReq, {
		onSuccess: (data) => {
			setIsRemoveModalOpen(false);
			setDashboards(
				dashboardList.filter((dashboard) => dashboard._id != dashboardId)
			);
			dispatch(
				SetNotificationAction({
					type: stateNotificationsEnum.SUCCESS,
					message: 'Successfully deleted dashboard.'
				})
			);
		},
		onError: () => {
			dispatch(
				SetNotificationAction({
					type: stateNotificationsEnum.ERROR,
					message: "couldn't delete topic."
				})
			);
		}
	});

	const deleteDash = (userId: string, dashboardId: string) => {
		if (defaultDash == dashboardId) {
			if (dashboardId == dashboardList[0]._id)
				setDefaultDashboard(userId, dashboardList[1]._id);
			else setDefaultDashboard(userId, dashboardList[0]._id);
		}

		setIsRemoveModalOpen(false);
		mutate({ userId, dashboardId });
	};

	interface ISetDefaultDash {
		userId: string;
		dashboardId: string;
	}
	const setDefaultDashReq = async (data: ISetDefaultDash) => {
		setDefaultDash(data.dashboardId);
		const params = new URLSearchParams();
		params.append('dashboardId', data.dashboardId);
		params.append('userId', data.userId);
		const config = {
			headers: {
				Authorization: 'Bearer ' + ACCESS_TOKEN
			}
		};
		const { data: response } = await axiosInstance().put(
			globalEnv.BASE_URL + '/admin/dashboard/set-default',
			params,
			config
		);
		return response;
	};

	const setDefaultDashboardMutate = useMutation(setDefaultDashReq, {
		onSuccess: (data) => {
			console.log(data);
		},
		onError: () => {
			setDefaultDash(dashboardId);
		}
		// onSettled: () => {
		// 	queryClient.invalidateQueries('create');
		// }
	});

	const setDefaultDashboard = (userId: string, dashboardId: string) => {
		setDefaultDashboardMutate.mutate({ userId, dashboardId });
	};

	const navigate = useNavigate();

	const ref: any = useRef<null>(null);

	return (
		<div
			className="card-zoom cursor-pointer"
			onClick={() => navigate(`../dashboard/${dashboardId}`)}
			ref={ref}
		>
			<RemoveModal
				title={'Remove Dashboard'}
				text={'Are you sure you want to remove this dashboard?'}
				setModalOpen={setIsRemoveModalOpen}
				setAction={() => {
					return deleteDash(userId, dashboardId);
				}}
				visible={isRemoveModalOpen}
			/>
			<div
				className="card-zoom-image"
				style={{
					backgroundImage: `url('${image}')`
				}}
			/>
			<h1
				// Gets the width of the parent and determines the font size from it
				style={{
					fontSize: ref.current ? ref.current.offsetWidth / 6 : '2em'
				}}
				className={
					defaultDash === dashboardId
						? 'card-zoom-text-default opacity-60'
						: 'card-zoom-text-default opacity-0'
				}
			>
				DEFAULT
			</h1>

			<div className="absolute inset-0 bg-gradient-to-t from-black/75 opacity-0 hover:opacity-100 transition-all duration-500 text-center">
				<div className="group">
					<div className="absolute right-2 top-2 w-10">
						<input
							type="checkbox"
							name="toggle"
							id="Purple"
							className="checked:bg-purple-500 outline-none focus:outline-none right-4 checked:right-0 duration-200 ease-in absolute block w-6 h-6 rounded-full bg-gray-800 border-4 appearance-none cursor-pointer"
							checked={defaultDash === dashboardId}
							disabled={dashboardList.length === 1}
							onClick={(e) => e.stopPropagation()}
							onChange={(e) => {
								if (e.target.checked) {
									setDefaultDashboard(userId, dashboardId);
								} else {
									if (dashboardId == dashboardList[0]._id)
										setDefaultDashboard(userId, dashboardList[1]._id);
									else setDefaultDashboard(userId, dashboardList[0]._id);
								}
							}}
						/>
						<label className="block overflow-hidden h-6 rounded-full bg-gray-800 cursor-pointer"></label>
					</div>

					<span
						className="absolute rounded-md shadow-md text-white bg-gray-900 p-2 min-w-max text-xs
						font-bold transition-all duration-500 opacity-0 group-hover:opacity-100 top-1 right-14"
					>
						{dashboardList.length === 1
							? "Can't update 🚫"
							: 'Set default ❌✅'}
					</span>
				</div>
				<div className="group">
					<button
						className="absolute top-2 left-2 btn-error btn-xs btn btn-circle btn-outline shadow-md"
						onClick={(e) => {
							if (dashboardList.length > 1) {
								e.stopPropagation();
								setIsRemoveModalOpen(true);
							}
						}}
					>
						<BsXLg />
					</button>
					<span
						className="absolute rounded-md shadow-md text-white bg-gray-900 p-2 min-w-max text-xs
						scale-0 origin-left group-hover:scale-100
						font-bold transition-all duration-500 opacity-0 group-hover:opacity-100 top-1 left-10"
					>
						{dashboardList.length === 1 ? "Can't remove 🚫" : 'Remove ❌'}
					</span>
				</div>
				<h1 className="card-zoom-text mt-44">{name}</h1>
			</div>
		</div>
	);
}
